import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DidacticFunctionApi } from '../+api';
import { DidacticFunctionInterface } from '../+models/DidacticFunction.interface';
import { DidacticFunctionServiceInterface } from './didactic-function.service.interface';

@Injectable({
  providedIn: 'root',
})
export class DidacticFunctionService implements DidacticFunctionServiceInterface {
  private didacticFunctionApi = inject(DidacticFunctionApi);

  getAll(): Observable<DidacticFunctionInterface[]> {
    return this.didacticFunctionApi.find();
  }

  getDidacticFunctions$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: DidacticFunctionInterface[]; count: number }> {
    const params = new HttpParams({
      fromObject: {
        searchTerm: searchTerm || '',
        filters: JSON.stringify(filters || {}),
        columns: JSON.stringify(columns || null),
        sorting: JSON.stringify(sorting || {}),
        pagination: JSON.stringify(pagination || {}),
      },
    });
    return this.didacticFunctionApi.getDidacticFunctions(params);
  }

  deleteDidacticFunction$(id: number): Observable<boolean> {
    return this.didacticFunctionApi.deleteById(id);
  }

  createDidacticFunction(didacticFunction: DidacticFunctionInterface): Observable<DidacticFunctionInterface> {
    return this.didacticFunctionApi.createDidacticFunction(didacticFunction);
  }

  updateDidacticFunction(didacticFunction: DidacticFunctionInterface): Observable<DidacticFunctionInterface> {
    const params = new HttpParams({
      fromObject: {
        id: didacticFunction.id?.toString(),
      },
    });
    return this.didacticFunctionApi.updateDidacticFunction(params, didacticFunction);
  }
}
